import React, { useContext } from "react";
import { StyleSheet, Modal } from "react-native";
import { Avatar, IconButton } from "react-native-paper";
import { BlurView } from "expo-blur";
import { View } from "../../shared/Themed";
import { useAppTheme } from "../../../hooks/useAppTheme";

import DeviceOrientationContext from "../../context/DeviceOrientationContext";
import { ReadOnlyProps } from "../../../utils/templates";

interface Props {
  childern: React.ElementType;
  modalVisible?: boolean;
  isMobileDevice?: boolean;
  setModalVisible: (event: any) => void;
}

export const ModalContainer: React.FC<ReadOnlyProps<Props>> = (
  props: ReadOnlyProps<Props>
) => {
  const Children = props.childern;
  const { isMediumDevice, isSmallDevice } = useContext(
    DeviceOrientationContext
  );
  const { colors } = useAppTheme();
  const styles = createStyles(colors);

  return (
    <View>
      <Modal
        animationType="slide"
        transparent={true}
        visible={props.modalVisible}
        onRequestClose={() => {
          props.setModalVisible(!props.modalVisible);
        }}
      >
        <BlurView intensity={5} style={styles.centeredView}>
          <View
            style={[
              styles.modalView,
              {
                width: isSmallDevice ? "95%" : undefined,
                minWidth: props.isMobileDevice
                  ? "92%"
                  : isSmallDevice
                  ? "95%"
                  : isMediumDevice
                  ? "30%"
                  : "24%",
                minHeight: props.isMobileDevice
                  ? "28%"
                  : isSmallDevice
                  ? "70%"
                  : "80%",
                maxHeight: props.isMobileDevice
                  ? "28%"
                  : isSmallDevice
                  ? "90%"
                  : "95%",
              },
            ]}
          >
            {props.childern && <Children {...props} />}
          </View>
        </BlurView>
      </Modal>
    </View>
  );
};

const createStyles = (colors: any) => StyleSheet.create({
  centeredView: {
    flex: 1,
    justifyContent: "center",
    alignItems: "center",
  },
  modalView: {
    margin: 20,
    backgroundColor: "transparent",
    alignItems: "center",
    justifyContent: "center",
  },
  button: {
    marginTop: 10,
    minWidth: "1%",
    borderRadius: 20,
    padding: 10,
    elevation: 2,
    borderWidth: 1,
    borderColor: colors.border,
    backgroundColor: colors.surfaceSubtle,
  },
  textStyle: {
    color: "white",
    fontWeight: "bold",
    textAlign: "center",
  },
  modalText: {
    marginBottom: 15,
    textAlign: "center",
  },
});
